// This empty API is used to inject endpoints with OpenAPI codegen
// https://redux-toolkit.js.org/rtk-query/usage/code-generation#openapi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { WebReducerState } from '../reducers/types';

export const baseSchedulerApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: '/scheduler',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as WebReducerState).auth?.accessToken;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
